import React, {useState} from 'react'

import circle_green from '../../../../images/internShips/curcle.svg'
import circle from '../../../../images/main/curcle.svg'
import {ReactComponent as Minus} from '../../../../images/main/minus_usefulInfo.svg'
import {ReactComponent as Plus} from '../../../../images/main/plus_usefulInfo.svg'
import parse from "html-react-parser";

import styles from './styles.module.scss'
import $ from "jquery";

const DirectInternShips = ({refForm}) => {
  const [activeSeason, setActiveSeason] = useState(0)
  const [activeField, setActiveField] = React.useState(0)

  const season = ['Летняя стажировка', 'Зимняя стажировка']
  const ScrollForm = () => {
    let btop = $("#form").offset().top - $('#root .layout_header').offset().top - 80;
    $("html, body").animate({
      scrollTop: btop
    }, 2000);
  }
  const nameInternShips = [
    {
      title: 'Фармацевтический анализ, аналитическое обеспечение (п.&nbsp;Вольгинский)*',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Приготовление растворов;</li>' +
        '<li>Проведение испытаний следующими методами:<br>общими(спектрофотометрический, потенциометрический, криоскопический, электрофорез, изоэлектрическое фокусирование, LAL-тест) или ИФА, или КЭ;</li>' +
        '<li>Оформление результатов полученных данных.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Высшее профессиональное образование (химическое, биологическое, медицинское, фармацевтическое, ветеринарное и др. аналогичного профиля);</li>' +
        '<li>Знание регуляторных документов (ФЗ №61, ГОСТ Р ИСО 9001, решение № 89, Фармакопея Евразийского экономического союза, ГФ РФ XIV и XV издания);</li>' +
        '<li>Знание физико-химических и/или иммунохимических методов контроля (спектрофотометрический, потенциометрический, криоскопический, электрофорез, изоэлектрическое фокусирование, LAL-тест, ВЭЖХ, ИФА, КЭ и т.п.).</li>' +
        '</ul>' +
        '<p>*при успешном прохождении стажировки ты можешь получить приглашение на работу в 2026 г.</p>'
    },
    {
      title: 'Фармацевтический анализ, разработка физико-химических методов (п.&nbsp;Вольгинский)*',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Выполнение общелабораторных задач: приготовление растворов, подготовка оборудования к работе, поддержание чистоты в лаборатории;</li>' +
        '<li>Освоение ВЭЖХ на уверенном уровне;</li>' +
        '<li>Сдача экзамена по СМК;</li>' +
        '<li>Участие в разработке АМ и подготовка выступления (обобщение результатов разработки).</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Знание молекулярной биологии (синтез белка, получение рекомбинантных белков, структура гликопротеинов (хотя бы на примере МАТ), аналитическая химия (знание расчета количества вещества (молярность, разведения), смешивание растворов, точность взвешивания), теория ВЭЖХ, знание ICH или MAbCaseStudy как преимущество.</li>' +
        '</ul>' +
        '<p>Практические навыки:</p>' +
        '<ul>' +
        '<li>Умение работать автоматическим дозатором, рН-метром (калибровка, измерение, очистка), на весах, в т.ч. аналитических (5 знаков);</li>' +
        '<li>Приготовление буферных и органических  растворов и их смесей;</li>' +
        '<li>Умение ставить электрофорез или другой аналитический метод как преимущество. </li>' +
        '</ul>' +
        '<p>*при успешном прохождении стажировки ты можешь получить приглашение на работу в 2026 г.</p>'
    },
    {
      title: 'Фармацевтический анализ, масс-спектрометрия (п.&nbsp;Вольгинский)*',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Подготовка образцов белков к масс-спектрометрическому анализу;</li>' +
        '<li>Участие в проведении рутинных испытаний (межоперационный контроль производства);</li>' +
        '<li>Участие в сопровождении разработок проектов;</li>' +
        '<li>Выполнение вспомогательных операций: учёт реактивов и материалов, заполнение реестров и журналов и т.д.;</li>' +
        '<li>Обучение по СМК GMP.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Понимание процессов и/или умение работать методами ВЭЖХ или ВЭЖХ-МС;</li>' +
        '<li>Знания в области химии белка и/или методов аналитической химии белка;</li>' +
        '<li>Понимание фармацевтической системы качества или понимание процессов разработки методик.</li>' +
        '</ul>' +
        '<p>*при успешном прохождении стажировки ты можешь получить приглашение на работу в 2026 г.</p>'
    },
    {
      title: 'Клеточная биология (п.&nbsp;Вольгинский)',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Работа с клетками;</li>' +
        '<li>Разработка клонов-продуцентов;</li>' +
        '<li>Работа с методами ИФА и вестерн-блот;</li>' +
        '<li>Подсчет клеток.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Высшее образование (биологическое, биотехнологическое, химическое);</li>' +
        '<li>Знание теории клеточного строения.</li>' +
        '</ul>'
    },
    {
      title: 'Контроль качества, валидация (п.&nbsp;Вольгинский)',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Ознакомление с требованиями GMP, российскими и международными стандартами в области валидации/квалификации, регламентирующими документами по валидации/квалификации;</li>' +
        '<li>Освоение теоретических аспектов валидации/квалификации;</li>' +
        '<li>Участие в разработке протоколов и отчетов валидации процессов в соответствии с требованиями регламентирующей и нормативной документации;</li>' +
        '<li>Участие в планировании валидационных работ;</li>' +
        '<li>Участие в заполнении разработанных протоколов валидации по результатам проведенных валидационных испытаний;</li>' +
        '<li>Участие в обработке и интерпретации полученных результатов валидации, проверка сопутствующих валидации документов;</li>' +
        '<li>Помощь в систематизации и централизации информации по валидации процессов.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Приоритетные направления образования: химическое, биотехнологическое, биохимическое, биологическое, фармацевтическое, инженерно-технологическое;</li>' +
        '<li>Интерес к работе в фармацевтической отрасли;</li>' +
        '<li>Готовность к обучению и освоению новой области знаний;</li>' +
        '<li>Готовность работать с большим объемом информации и документации;</li>' +
        '<li>Умение структурировать и анализировать информацию;</li>' +
        '<li>Уверенный пользователь ПК;</li>' +
        '<li>Знание основ GMP и статистических методов обработки данных, как преимущество.</li>' +
        '</ul>' +
        '<p>Личные качества кандидата</p>' +
        '<ul>' +
        '<li>Аналитический склад ума и критическое мышление;</li>' +
        '<li>Скрупулезность и внимание к деталям;</li>' +
        '<li>Высокая степень ответственности и организованности;</li>' +
        '<li>Исполнительность;</li>' +
        '<li>Инициативность;</li>' +
        '<li>Умение работать в команде.</li>' +
        '</ul>'
    },
    {
      title: 'Контроль качества, биологический и биохимический контроль (п.&nbsp;Вольгинский)*',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Проведение контроля качества лекарственных средств в GMP условиях;</li>' +
        '<li>Освоение биолигических и биохимических методов контроля: электрофорез в ПААГ и в агарозном геле, изоэлектрическое фокусирование, капиллярный электрофорез ИФА, ПЦР, клеточные тесты, спектрофотометрические методы, коагулометрия;</li>' +
        '<li>Приготовление растворов, проведение расчетов, осуществление записей. Основы работы и функционирования лаборатории в GMP условиях;</li>' +
        '<li>Соблюдение требований прослеживаемости результатов контроля.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Знание биохимии и основ GMP;</li>' +
        '<li>Теоретическая база в части биохимических и биологических методов;</li>' +
        '<li>Владение навыками работы в лаборатории;</li>' +
        '<li>Умение проводить самостоятельно расчеты;</li>' +
        '<li>Инициативность.</li>' +
        '</ul>' +
        '<p>*при успешном прохождении стажировки ты можешь получить приглашение на работу в 2026 г.</p>'
    },
    {
      title: 'Контроль качества, контроль технологических процессов (п.&nbsp;Вольгинский)*',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Подготовка лабораторной посуды, проведение контроля технологических сред, подготовка рабочих мест;</li>' +
        '<li>Проведение контроля воды, определение содержания бактериальных эндотоксинов, рН, электропроводности и осмоляльности, спектрофотометрия.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Знание правил работы с химическими реактивами;</li>' +
        '<li>Внимательность и аккуратность;</li>' +
        '<li>Стрессоустойчивость, умение работать в коллективе.</li>' +
        '</ul>' +
        '<p>*при успешном прохождении стажировки ты можешь получить приглашение на работу в 2026 г.</p>'
    },
    {
      title: 'Производство (Алабушево)*',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Разработка технологических инструкций по подготовке (очистке) оборудования, по переодеванию персонала и входа в "чистые" помещения С класса чистоты;</li>' +
        '<li>Расчет норм расхода для производства одной серии препарата;</li>' +
        '<li>Разработка URS на новой оборудование;</li>' +
        '<li>Контроль ведения и заполнения журналов за персоналом цеха;</li>' +
        '<li>Разработка анализа рисков по отсутствию перекрестной контаминации при внедрении нового препарата на существующие линии производства ГЛФ.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Умение работать в команде;</li>' +
        '<li>Знание основ инженерии, т.к. в цехах установлено современное оборудование и нужно будет разобраться в принципах его работы.</li>' +
        '</ul>' +
        '<p>*при успешном прохождении стажировки ты можешь получить приглашение на работу в 2026 г.</p>'
    },
    {
      title: 'Контроль качества (Алабушево)*',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Калибровка оборудования;</li>' +
        '<li>Проведение контролей по физико-химическим показателям;</li>' +
        '<li>Работа с реактивами - прием, учет, списание;</li>' +
        '<li>Приготовление растворов;</li>' +
        '<li>Контроль воды по физико-химическим показателям;</li>' +
        '<li>Мытье лабораторной посуды;</li>' +
        '<li>Сканирование документов ОКК.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Химико-технологическое, биотехнологическое, фармацевтическое, химическое, биологическое образование;</li>' +
        '<li>Знание физико-химических методов анализа.</li>' +
        '</ul>' +
        '<p>*при успешном прохождении стажировки ты можешь получить приглашение на работу в 2026 г.</p>'
    },
    {
      title: 'Клинические исследования (Москва)',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Ведение документооборота, проведение своевременной и корректной загрузки документов по всем аспектам клинического исследования в электронные базы данных;</li>' +
        '<li>Сбор основных документов КИ;</li>' +
        '<li>Участие в подготовке документов КИ для подачи в МЗ и НЭКи. Формирование  Файла Исследователя (ФИ) и Главного Файла Центра (ГФЦ);</li>' +
        '<li>Помощь в повседневных задачах Специалистам по Организации КИ.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Умение работать с документами;</li>' +
        '<li>Аккуратность, внимательность, быстрая обучаемость, активность в работе, нацеленность на результат;</li>' +
        '<li>Базовые знания английского языка;</li>' +
        '<li>Умение работать с электронными системами приветствуется.</li>' +
        '</ul>'
    },
    {
      title: 'Прозводство, хроматографическая очистка (п.&nbsp;Вольгинский)*',
      desc: '<div>Задачи, которые стажеры будут выполнять во время стажировки</div>' +
        '<ul>' +
        '<li>Проводение процессов хроматографической очистки биологических ЛС;</li>' +
        '<li>Контроль режимов и параметров технологических процессов выделения и очистки белков;</li>' +
        '<li>Подготавливка к работе технологическое оборудование;</li>' +
        '<li>Участие в ведении технологической документации, а также учете расхода сырья и материалов.</li>' +
        '</ul>' +
        '<div>Требования к стажерам</div>' +
        '<ul>' +
        '<li>Высшее профессиональное (химическое, биотехнологическое, биохимическое, биологическое, фармацевтическое, химико-технологическое, ветеринарное) образование;</li>' +
        '<li>Опыт работы с вспомогательным оборудованием (дозаторы, центрифуги, анализаторы жидкости, весы, TFF);</li>' +
        '<li>Опыт работы с хроматографическими системами (аналитические хроматографы, препаративные хроматографы) как преимущество;</li>' +
        '<li>Владение следующими знаниями: теоретические основы хроматографической очистки белковых молекул, общее понимание масштабирования процессов хроматографической очистки, требования GMP к процессу производства, требования к работе в чистых помещениях и асептической работе.</li>' +
        '</ul>' +
        '<p>*при успешном прохождении стажировки ты можешь получить приглашение на работу в 2026 г.</p>'
    },
  ]

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <p className={styles.title}>Выбери свою стажировку</p>
        <div className={styles.list_scroll_box}>
          <div className={styles.wrapper_list}>
            {/*season.map((item, index) => (
              // <div className={styles.list} key={index}>
              //   <svg
              //     width='8'
              //     height='8.5'
              //     viewBox='0 0 8 9'
              //     xmlns={activeSeason === index ? circle_green : circle}
              //     className={activeSeason === index ? styles.circle_active : styles.circle}
              //   >
              //     <path
              //       d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z'/>
              //   </svg>
              //   <p
              //     onClick={() => {
              //       if (index === "Летняя стажировка") {
              //         setActiveSeason(index)
              //         setActiveField(null)
              //       }
              //     }}
              //     className={activeSeason === index ? styles.title_name_active : styles.title_name}
              //   >
              //     {item}
              //   </p>
              // </div>
            )) */}
          </div>
        </div>
        <div className={styles.down_side}>
          <div className={styles.down_list}>
            {/*<div className={styles.down_side_item}>*/}
            {/*  <p className={styles.down_side_item_p1}>{activeSeason === 1 ? 'ноябрь' : 'май'}</p>*/}
            {/*  <p className={styles.down_side_item_p2}>проведение отборочных испытаний</p>*/}
            {/*</div>*/}

            <div className={styles.down_side_item}>
              <p className={styles.down_side_item_p1}>1-3 месяца</p>
              <p className={styles.down_side_item_p2}>длительность стажировки определяешь ты</p>
            </div>

            <div className={styles.down_side_item}>
              <p className={styles.down_side_item_p1}>{activeSeason === 1 ? 'январь-март' : 'июнь-август'}</p>
              <p className={styles.down_side_item_p2}>время проведения стажировки</p>
            </div>

            <div className={styles.down_side_item}>
              <p className={styles.down_side_item_p1}>пос. Вольгинский</p>
              <p className={styles.down_side_item_p2}>место проведения стажировки</p>
            </div>
          </div>
          <div>
            {/*<p>Принимаем заявки с {activeSeason === 1 ? 'октября по ноябрь' : 'апреля по май'}</p>*/}
            {/* <button onClick={() => ScrollForm()}>
              Заполнить анкету <span>&rarr;</span>
            </button> */}
          </div>
        </div>
      </div>
      <div className={styles.right} id='directions-intern-ships'>
        <p className={styles.title}>Направления стажировок</p>
        <div className={styles.right_wrapper}>
          {activeSeason === 1 ? (
            <>
              {nameInternShips.map((item, index) => (
                <div key={index} className={styles.righ_wrapper_item}>
                  <div className={styles.right_item}>
                    <div className={styles.right_item_questions}>
                      <p
                        onClick={() => (activeField ? setActiveField(null) : setActiveField(index + 1))}
                        className={
                          activeField === index + 1
                            ? styles.questions
                            : styles.questions_disable
                        }
                      >
                        {parse(item.title)}
                      </p>
                      {activeField === index + 1 ? (
                        <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
                      ) : (
                        <Plus className={styles.right_item_img} onClick={() => setActiveField(index + 1)}/>
                      )}
                    </div>
                    {activeField === index + 1 && (
                      <>
                        <div className={styles.answer}>
                          {parse(item.desc)}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <>
              {nameInternShips.map((item, index) => (
                <div key={index} className={styles.righ_wrapper_item}>
                  <div className={styles.right_item}>
                    <div className={styles.right_item_questions}>
                      <p
                        onClick={() => (activeField ? setActiveField(null) : setActiveField(index + 1))}
                        className={
                          activeField === index + 1
                            ? styles.questions
                            : styles.questions_disable
                        }
                      >
                        {parse(item.title)}
                      </p>
                      {activeField === index + 1 ? (
                        <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
                      ) : (
                        <Plus className={styles.right_item_img} onClick={() => setActiveField(index + 1)}/>
                      )}
                    </div>
                    {activeField === index + 1 && (
                      <>
                        <div className={styles.answer}>
                          {parse(item.desc)}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
              {/*<div className={styles.wrapper_form}>*/}
              {/*  <p className={styles.wrapper_form_p1}>Набор на летнюю стажировку начнется с апреля.</p>*/}
              {/*  <p className={styles.wrapper_form_p2}>*/}
              {/*    Оставь свой email, и мы сообщим тебе, когда опубликуем информацию о направлениях и датах летней*/}
              {/*    стажировки.*/}
              {/*  </p>*/}
              {/*  <form className={styles.wrapper_form_block}>*/}
              {/*    <label>*/}
              {/*      Электронная почта*/}
              {/*      <input placeholder='Например, example@example.com'/>*/}
              {/*    </label>*/}

              {/*    <div className={styles.wrapper_form_block_success}>*/}
              {/*      <input type='checkbox'/>*/}
              {/*      <p>Я даю согласие на обработку моих персональных данных</p>*/}
              {/*    </div>*/}

              {/*    <button>*/}
              {/*      Подписаться на новости <span>&rarr;</span>*/}
              {/*    </button>*/}
              {/*  </form>*/}
              {/*</div>*/}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default DirectInternShips
